var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visualizer-wrapper d-none d-sm-flex",class:{'paused': _vm.paused}},_vm._l((_vm.amount),function(num){return _c('div',{key:num,staticClass:"visualizer",style:({'--index':  num})})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }